import Aggregate from '../aggregates/aggregate';

export default class Envelope extends Aggregate {}
